const app = [
  "App Market",
  "Alarm",
  "Chrome",
  "Android Studio",
  "Visual Studio Code",
  "Sublime Text 3",
  "Groove",
  "Adobe Photoshop",
  "Adobe Dreamweaver",
  "Adobe XD",
  "GO",
  "Setting",
  "Python 3",
  "Adobe Premiere",
  "Adobe Flash",
  "Node JS",
  "Deno JS",
  "Calculator",
  "Calender",
  "Cisco Packet Tracker",
  "Ubuntu LTS",
  "Kali Linux",
  "Command Prompt",
  "Power Shell",
  "File Manager",
  "Outlook",
  "Spotify"
];

export default app;
